import React from "react";
import { Alert } from "../../../../components/src/Alert";
import { useParams } from "wouter";

import { useQueryState } from "../../../../components/src/use-query-state";
import { DateForm } from "../../../../components/src/dateForm";
import { FxRisk } from "./FxRisk";
import { PmSelectPrompt } from "./PmSelectPrompt";

export interface Props {
    lookThrough: boolean;
}

const check_today_date = (endDate: string) => {
    const today = new Date().toISOString().slice(0, 10);
    if (endDate === today) {
        return true;
    } else {
        return false;
    }
};

export const FxRiskView = (props: Props): React.ReactElement => {
    const [endDate] = useQueryState("endDate", new Date().toISOString().slice(0, 10));
    const { id } = useParams<{ id: string }>();

    if (typeof id === "undefined" || id === "all") {
        return <PmSelectPrompt message="Select a client" />;
    }
    return (
        <div>
            <div className="flex">
                <DateForm defaultDateString={endDate} dateName="endDate"></DateForm>
                {!check_today_date(endDate) ? (
                    <Alert variant="danger" className="ml-2">
                        Historical or future date selected
                    </Alert>
                ) : null}
            </div>
            <br />
            <FxRisk clientId={id} endDate={endDate} lookThrough={props.lookThrough} />
        </div>
    );
};
